import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { TunnelClient } from './client.js';

export function useTunnelClient(): TunnelClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  const client = useMemo(() => new TunnelClient(httpClient), [httpClient]);

  return usePanoramaMethodLogger(client);
}
